"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = exports.colours = void 0;
exports.colours = {
    purple: "#89016F",
    pink: "#FF1552",
    red: "#FF2C20",
    orange: "#FF6222",
    salmon: "#F7DEDB",
    white: "#fff",
    black: "#251010",
    grey: "#928888",
    green: "#4BB543",
};
exports.palette = {
    primary: {
        main: exports.colours.red,
    },
    secondary: {
        main: exports.colours.purple,
    },
    success: {
        main: exports.colours.green,
    },
    body: { main: exports.colours.black },
    grey: {
        main: exports.colours.grey,
    },
    background: {
        default: exports.colours.white,
    },
};
//# sourceMappingURL=palette.js.map